import AdminQuestionsThematicIndex from '@/pages/admin/questions/thematic/Index'
import AdminQuestionsThematicAdd from '@/pages/admin/questions/thematic/Add'
import AdminQuestionsThematicEdit from '@/pages/admin/questions/thematic/Edit'

export default [
  {
    path: '/admin/questions/thematic',
    name: 'AdminQuestionsThematicIndex',
    component: AdminQuestionsThematicIndex,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/thematic/add',
    name: 'AdminQuestionsThematicAdd',
    component: AdminQuestionsThematicAdd,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/thematic/edit/:id',
    name: 'AdminQuestionsThematicEdit',
    component: AdminQuestionsThematicEdit,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/questions/thematic.js